import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import type {
  OcPromoBannerData,
  OcPromoBannerVariant,
  OcPromoBannerTestResult,
  UseOcPromoBanner,
} from "./types";

const CUSTOM_RULE_ID = "ocPromoBanner";

/**
 * Hook for the Open Course promo banner experiment.
 * This experiment can return one of the following variants:
 * - ocPromoBannerControl: No banner
 * - ocPromoBannerVariantA: Slim banner below the hero
 * - ocPromoBannerVariantB: Bento banner next to the About section
 */
const useOcPromoBanner: UseOcPromoBanner = () => {
  // Call the Monarch API to get the experiment result
  const { isLoading, value } = useMonarchRule<{
    data: OcPromoBannerData;
    variantCustomId: OcPromoBannerVariant;
  }>(CUSTOM_RULE_ID, {});

  // If still loading or no value returned, return loading state
  if (isLoading || !value) {
    return {
      isLoading,
    } as OcPromoBannerTestResult;
  }

  // Return the experiment result with proper typing
  return {
    isLoading: false,
    variant: value.variantCustomId,
    data: value.data,
  };
};

export default useOcPromoBanner;
